import { SEND_CONTACT_DATA } from '../types/const.js';
import fetch from 'node-fetch';
import { stringify  } from 'qs';
export const aContent = (uName, uMail, uMess) => {
  const param = {
    'select_val':'g_sendmess',
    'uname_val':uName,
    'umail_val':uMail,
    'umess_val':uMess
  };

  return dispatch => {
    const host = 'http://127.0.0.1:3002/';
    const bodytext = `${stringify(param)}`;

    fetch(host, {
      method: 'POST',
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: bodytext
    }
    )
      .then(res => res.json())
      .then(json => console.log(json));
    //    let jsonReq= [...jsonData];
    //  dispatch( { type: SEND_CONTACT_DATA , aSendCont: jsonReq } );
  };
};



// WEBPACK FOOTER //
// ./src/client/action/sendmail.js